<template>
  <div>
    <template v-if="isCleanAdminRoute">
      <div class="min-h-screen bg-slate-100">
        <header class="border-b border-slate-200 bg-white">
          <div class="mx-auto flex max-w-7xl items-center justify-between px-4 py-4 sm:px-6 lg:px-8">
            <div>
              <p class="text-xs font-semibold uppercase tracking-[0.2em] text-slate-500">Admin Area</p>
              <h1 class="text-lg font-semibold text-slate-900">{{ adminAreaTitle }}</h1>
            </div>
            <router-link to="/" class="text-sm font-medium text-slate-600 transition hover:text-slate-900">
              Back to site
            </router-link>
          </div>
        </header>

        <section class="mx-auto max-w-7xl px-4 py-6 sm:px-6 lg:px-8">
          <router-view :key="$route.fullPath" />
        </section>
      </div>
    </template>

    <template v-else>
      <NavBar></NavBar>
      <router-view :key="$route.fullPath"/>
      <Footer></Footer>
    </template>

    <Notification></Notification>
    <WatchOnModal></WatchOnModal>
    <AccessModal></AccessModal>
    <ErrorModal></ErrorModal>
    <LoadingModal></LoadingModal>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import NavBar from '@/components/NavBar.vue'
import Footer from '@/components/Footer.vue'
import WatchOnModal from '@/components/global/WatchOnModal.vue'
import AccessModal from '@/components/global/AccessModal.vue'
import ErrorModal from '@/components/global/ErrorModal.vue'
import LoadingModal from '@/components/global/LoadingModal.vue'
import Notification from '@/components/Notification.vue'
export default defineComponent({
  name: 'App',
  components: {
    NavBar,
    Footer,
    Notification,
    WatchOnModal,
    AccessModal,
    ErrorModal,
    LoadingModal
  },
  computed: {
    isCleanAdminRoute () {
      return this.$route.matched.some(route => route.meta.cleanAdmin)
    },
    adminAreaTitle () {
      if (this.$route.meta && this.$route.meta.adminAreaTitle) {
        return this.$route.meta.adminAreaTitle
      }

      return 'Admin'
    }
  }
})
</script>
